import React, { Component } from 'react';
import { connect } from "react-redux";
import Grid from '../../../components/grid';
import { adjustment401kReport, } from '../../../store/actions';
import './style.scss';
import Select from 'react-select';
class Adjustment401kView extends Component {


    state = {
        loading: false,

        rowData: null,
        columnDefs: [
            {
                headerName: "Employee Id",
                field: "employeeId"
            }, {
                headerName: "Employee Last Name",
                field: "empLastName",
            }, {
                headerName: "Employee First Name",
                field: "empFirstName"
            },
            {
                headerName: "CC1",
                field: "jobCode"
            },
            {
                headerName: "CC7",
                field: "distCode"
            },
            {
                headerName: "Sum of Eligible HS Deduction",
                field: "amount"
            },
            {
                headerName: "D/T ER Amount",
                field: "ERMatch"
            },
            {
                headerName: "E/D/T Name",
                field: "EDTName"
            },
            {
                headerName: "E/D/T",
                field: "EDTType"
            },
            {
                headerName: "Pay Statement Type",
                field: "payStatementType"
            },
            {
                headerName: "Payroll ID",
                field: "payrollId"
            }
        ]
    };

    async componentDidMount() {
        this.setState({
            loading: true,
        });
        await this.props.adjustment401kReport({ company: this.props.UserReducer.company });
        this.setState({
            loading: false,
            rowData: this.props.REPORT_401K
        });
    };

    render() {

        const { loading, firstSelectOptions, secondSelectOptions, selectedFirstPayroll, selectedSecondPayroll } = this.state;

        return (
            <>
                <div className="shadow_white_box full-box mt-0">
                    <Grid
                        columnDefs={this.state.columnDefs}
                        rowData={this.state.rowData}
                        height='600px'
                    >
                    </Grid>

                </div>
            </>
        )
    }
}
const mapStateToProps = ({ UserReducer, PayrollComparisonsReducer }) => {
    const { REPORT_401K } = PayrollComparisonsReducer;
    return { UserReducer, REPORT_401K }
};

export default connect(mapStateToProps, {
    adjustment401kReport
})(Adjustment401kView);
